import {UPDATE_QUANTITY_PENDING, UPDATE_QUANTITY_SUCCESS, UPDATE_QUANTITY_ERROR } from '../actions/cart-actions';

const initialState = {
	loading: false,
	error: null,
};

const cartReducer = (state = initialState, action) => {
	switch(action.type){
		case UPDATE_QUANTITY_PENDING: {
			return {
				...state,
				loading: true,
				error: null,
			}
		}
		case UPDATE_QUANTITY_SUCCESS: {
			return {
				...state,
				loading: false,
				error: null,
			}
		}
		case UPDATE_QUANTITY_ERROR: {
			return {
				...state,
				loading: false,
				error: action.err
			}
		}
		default: {
			return state
		}
	}
};

export default cartReducer;
